/**
 * Agentic Chat Page
 * Pure conversational interface for ordering via AI
 * Demo Day - December 18, 2025
 */

import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { VoiceOrderingContainer } from '../../components/customer/VoiceOrdering/VoiceOrderingContainer';

const HARDCODED_RESTAURANT_ID = '6929b45104f29a0f03260391';

export default function Chat() {
  const [searchParams] = useSearchParams();
  const [restaurantId, setRestaurantId] = useState<string>('');
  const [tableId, setTableId] = useState<string>('');
  const [error, setError] = useState<string>('');

  useEffect(() => {
    // Parse URL parameters
    const restaurantIdParam = searchParams.get('restaurant_id') || HARDCODED_RESTAURANT_ID;
    const tableIdParam = searchParams.get('table_id');

    if (!tableIdParam) {
      setError('Missing table_id parameter. Please scan a valid QR code.');
      return;
    }

    setRestaurantId(restaurantIdParam);
    setTableId(tableIdParam);
  }, [searchParams]);

  // Error state
  if (error) {
    return (
      <div
        className="flex min-h-screen items-center justify-center p-4"
        style={{
          background: 'var(--background)',
        }}
      >
        <div
          className="max-w-md rounded-lg border p-6 text-center"
          style={{
            background: 'var(--alert-destructive-bg)',
            borderColor: 'var(--error-light)',
          }}
        >
          <h2 className="mb-2 text-lg font-semibold" style={{ color: 'var(--error)' }}>
            Invalid QR Code
          </h2>
          <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>
            {error}
          </p>
        </div>
      </div>
    );
  }

  // Loading state (waiting for params)
  if (!restaurantId || !tableId) {
    return (
      <div
        className="flex min-h-screen items-center justify-center"
        style={{
          background: 'var(--background)',
        }}
      >
        <div style={{ color: 'var(--text-secondary)' }}>Loading...</div>
      </div>
    );
  }

  // Main voice ordering interface
  return <VoiceOrderingContainer restaurantId={restaurantId} tableId={tableId} />;
}
